export const getSubscriptionBadgeColor = (status: string) => {
  switch (status) {
    case 'active':
    case 'Active':
    case 'ACTIVE':
      return 'success';
    case 'paused':
    case 'Paused':
    case 'PAUSED':
      return 'warning';
    case 'cancelled':
    case 'Cancelled':
    case 'CANCELLED':
      return 'danger';
    case 'inactive':
    case 'Inactive':
    case 'INACTIVE':
      return 'secondary';
    default:
      return 'secondary';
  }
};

export const getBillingStatusBadgeColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'succeeded':
      return 'success';
    case 'failed':
      return 'danger';
    case 'processing':
      return 'warning';
    case 'cancelled':
      return 'danger';
    case 'timed out':
      return 'info';
    default:
      return 'secondary';
  }
};

export const getPaymentStatusBadgeColor = (paymentStatus?: string | null) => {
  switch ((paymentStatus || 'unknown').toLowerCase()) {
    case 'paid':
      return 'success';
    case 'unknown':
      return 'warning';
    default:
      return 'danger';
  }
};
